import { Controller } from "@hotwired/stimulus";

const skipFrame = () =>
  new Promise((resolve) => requestAnimationFrame(resolve));
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Connects to data-controller="home-v2"
export default class extends Controller {
  connect() {
    const btns = [...this.element.querySelectorAll(".js-person-card-btn")];

    for (const btn of btns) {
      btn.addEventListener("click", this.handlePersonCardClick.bind(btn));
    }

    this.element
      .querySelector(".js-header-btn")
      ?.addEventListener("click", this.handleMenuToggle);
  }

  handleMenuToggle() {
    const menu = document.querySelector(".main-menu");
    menu.classList.toggle("opened");
    document.body.classList.toggle("overflow-hidden");
    document.body.classList.toggle("js-main-menu-opened");
  }

  async handlePersonCardClick() {
    const card = this.closest(".js-person-card");
    const content = this.closest(".js-person-card-content");
    const spacer = card.querySelector(".js-person-card-spacer");

    if (card.classList.contains("--animating")) return;

    card.classList.add("--animating");

    const opened = card.classList.contains("--opened");

    if (!opened) {
      card.classList.add("--opened");

      spacer.style.minHeight = `0px`;

      await skipFrame();

      const dY = card.clientHeight - content.clientHeight;

      spacer.style.minHeight = `${dY}px`;

      await wait(300);

      content.classList.add("tw:top-0");
      spacer.style.minHeight = "0px";

      await skipFrame();

      card.classList.remove("--animating");
      return;
    }

    card.classList.remove("--opened");

    content.style.top = `${spacer.clientHeight}px`;

    await wait(300);

    content.style.removeProperty("top");
    content.classList.remove("tw:top-0");

    await skipFrame();

    card.classList.remove("--animating");
  }
}
